import { PromptInputTodoList } from "./prompt-input-todo-list";
import { UsageLimitExceededCallout } from "./usage-limit-exceeded-callout";
import { cn } from "@/lib/utils";

export function PromptInputWrapper({
  children,
  isReadonly = false,
}: {
  isReadonly?: boolean;
  children: React.ReactNode;
}) {
  return (
    <>
      <div className={cn("rounded-[20px]")}>
        <div className="bg-sidebar p-[3px] rounded-[20px] relative">
          {!isReadonly && <UsageLimitExceededCallout />}
          <PromptInputTodoList />
          <div className="relative z-10">{children}</div>
        </div>
      </div>
    </>
  );
}
